import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CustomerDataDialogComponent } from './customer-data-dialog.component';

@NgModule({
  declarations: [CustomerDataDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [CustomerDataDialogComponent]
})
export class CustomerDataDialogModule { } 